"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    sihuaLu: 'A',
    sihuaQuan: 'B',
    sihuaKe: 'C',
    sihuaJi: 'D',
};
